export const LOAD_MOBILE_BONUS_INFO_START = 'LOAD_MOBILE_BONUS_INFO_START';
